import type { TeamModel } from '@/adapters/apiv1.g';
import type { Team } from '@/types/core/team';
import type { UUID } from '@/utils/uuid';

/**
 * Transform a backend TeamModel to a frontend Team type.
 * Handles snake_case to camelCase conversion and provides safe defaults.
 * @param model - API TeamModel response
 * @returns Team - UI-friendly Team object
 */
export function extractTeam(model: TeamModel): Team {
  const withRev = model as TeamModel & { _rev?: number };
  return {
    _rev: withRev._rev,
    teamId: model.team_id as UUID | undefined,
    tenantId: model.tenant_id as UUID | undefined,
    name: model.name,
    description: model.description,
    isSystem: model.is_system,
    active: model.active,
    reconciledAt: model.reconciled_at,
    memberCount: model.member_count,
  };
}
